export enum PubSubEvents {
  UpdateLiveStatus = "updateLiveStatus",
  UpdateIsShowGameLiveStats = "updateIsShowGameLiveStats",
  UpdateIsShowGameLiveStatsIcon = "UpdateIsShowGameLiveStatsIcon",
  ShowDialog = "ShowDialog",
  CloseDialog = "CloseDialog",
  StartCloseAnimation = "StartCloseAnimation",
  AddFlag = "AddFlag",
  RemoveFlag = "RemoveFlag",
  PostMessageToTWA = "PostMessageToTWA",
  UserInfoUpdated = "UserInfoUpdated",
  CallbackActivityIframe = "CallbackActivityIframe",
}
